import { Form } from '@/common/form/Form';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { DialogFormFieldContainer } from './DialogFormFieldContainer';

export const ActionDialog = ({ data, closeDialog }) => {
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const [fieldDefs, setFieldDefs] = useState();

  const formRef = useRef();

  useEffect(() => {
    rsrc
      .pluginFieldDefs(module, data.pluginCode, data.entity)
      .then((fieldDefs) => {
        if (data.augFieldDefs) {
          const fieldToFieldDef = Object.fromEntries(
            fieldDefs.map((fieldDef) => [fieldDef.field, fieldDef]),
          );
          data.augFieldDefs(fieldToFieldDef);
          fieldDefs = Object.values(fieldToFieldDef);
        }

        fieldDefs.sort((a, b) => (a.precedence || 0) - (b.precedence || 0));

        setFieldDefs(fieldDefs);
      });
  }, []);

  const submit = () => {
    if (formRef.current.hasErrorState()) {
      formRef.current.touchAll();
      return;
    }

    const actionReq = {
      ...formRef.current.formValues,
      ...data.addlReqData,
    };

    const job = {
      code: data.pluginCode.replace('_ACTION_PLUGIN', ''),
      name: data.title,
      module,
      entity: data.entity,
      entityId: data.entityId,
      rsrcCode: data.pluginCode,
      reqParamJson: JSON.stringify(actionReq),
      cat: 'ACTION',
      queueExempt: data.queueExempt ?? false,
    };

    rsrc.save('skdr', 'JOB', job).then((job) => {
      rsrc.start(job.id);
      closeDialog();
    });
  };

  return (
    <Dialog
      onClose={() => closeDialog()}
      open
      fullWidth
      data-test-id="action-dialog"
    >
      <DialogTitle>{data.title}</DialogTitle>
      <DialogContent>
        {fieldDefs && (
          <Form
            ref={formRef}
            fieldDefs={fieldDefs}
            container={DialogFormFieldContainer}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} data-test-id="cancel-button">
          Cancel
        </Button>
        <Button onClick={submit} data-test-id="submit-button">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
